module.exports = __webpack_public_path__ + "img/jbxxbg2.a630c69b.png";